// Community Q&A field limits -- MIRRORED from backend/core/community.py (the server
// is the authority and re-validates everything). Keep the numbers in step.
export const QUESTION_TITLE_MIN = 10;
export const QUESTION_TITLE_MAX = 200;
export const QUESTION_BODY_MIN = 20;
export const QUESTION_BODY_MAX = 10000;
export const ANSWER_MIN = 10;
export const ANSWER_MAX = 10000;
export const REPORT_DETAILS_MAX = 1000;

// Mirrors backend REPORT_REASONS (keys + labels).
export const REPORT_REASONS = [
  { value: 'spam', label: 'Spam or advertising' },
  { value: 'abusive', label: 'Abusive or harassing' },
  { value: 'off-topic', label: 'Off-topic or low quality' },
  { value: 'incorrect', label: 'Dangerous or incorrect advice' },
  { value: 'other', label: 'Other' },
];

const lengthError = (value, field, min, max) => {
  const len = (value || '').trim().length;
  if (len < min) return `${field} must be at least ${min} characters`;
  if (len > max) return `${field} must be at most ${max} characters`;
  return null;
};

export const validateQuestion = ({ title, description }) => {
  const errors = {};
  const t = lengthError(title, 'Title', QUESTION_TITLE_MIN, QUESTION_TITLE_MAX);
  const d = lengthError(description, 'Description', QUESTION_BODY_MIN, QUESTION_BODY_MAX);
  if (t) errors.title = t;
  if (d) errors.description = d;
  return errors;
};

export const validateAnswer = (content) => lengthError(content, 'Answer', ANSWER_MIN, ANSWER_MAX);

// FastAPI 422s carry `detail` as an array of {msg}; everything else is a string.
export const apiErrorMessage = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d.msg || '').replace(/^Value error, /, '')).filter(Boolean).join('; ') || fallback;
  }
  if (err?.response?.status === 429) return 'You are doing that too often. Please wait a few minutes and try again.';
  return detail || fallback;
};
